import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ThemeName } from '@shared/theme/tokens';

// Тема по умолчанию для всех, у кого нет валидного сохранённого выбора
// (новые пользователи + все, кому сбросили выбор бампом версии ключа ниже).
const DEFAULT_THEME: ThemeName = 'dark';

// Версионированный ключ хранения выбора темы. Бамп версии = разовый сброс
// сохранённого выбора у ВСЕХ: при следующем заходе старое значение больше не
// читается, человек стартует с DEFAULT_THEME, пока вручную не переключит.
export const STORAGE_KEY = 'osnova.theme.v2';
const LEGACY_STORAGE_KEYS = ['osnova.theme'];

// Имена тем до терракотового ребрендинга (25.10.2026): выбор светлой или
// тёмной сохраняется, просто под новым именем.
const RENAMED: Record<string, ThemeName> = { 'light-red': 'light', 'dark-red': 'dark' };

function readTheme(): ThemeName {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  if (stored && RENAMED[stored]) {
    localStorage.setItem(STORAGE_KEY, RENAMED[stored]);
    return RENAMED[stored];
  }
  // Нет валидного выбора под текущей версией ключа — подчищаем старые версии,
  // чтобы не копить мусор в localStorage, и отдаём тёмную по умолчанию.
  for (const key of LEGACY_STORAGE_KEYS) localStorage.removeItem(key);
  return DEFAULT_THEME;
}

const slice = createSlice({
  name: 'theme',
  initialState: { current: readTheme() as ThemeName },
  reducers: {
    setTheme(state, action: PayloadAction<ThemeName>) {
      state.current = action.payload;
      localStorage.setItem(STORAGE_KEY, action.payload);
    },
    toggleTheme(state) {
      state.current = state.current === 'light' ? 'dark' : 'light';
      localStorage.setItem(STORAGE_KEY, state.current);
    },
  },
});

export const { setTheme, toggleTheme } = slice.actions;
export default slice.reducer;
